import { useRef, useState } from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { APIProvider, Map, AdvancedMarker } from "@vis.gl/react-google-maps";
import PlaceAutocomplete from "../Business/Map/PlaceAutocomplete";


const BusinessSetUpModal = ({
  businessSetUpModalOpen,
  setBusinessSetUpModalOpen,
  handleBusinessChange,
  handleRegister,
  formError,
  setBusinessDetails,
  loading
}) => {
  const [selectedLocation, setSelectedLocation] = useState();
  
  const handlePlaceSelect = (location, address) => {
    setSelectedLocation(location);
    setBusinessDetails((prev) => ({...prev, location: location, address: address}))
  };

  const handleMapClick = (event) => {
    const lat = event.detail.latLng.lat;
    const lng = event.detail.latLng.lng;
    setSelectedLocation({ lat, lng });
    console.log("Selected Location:", { lat, lng });
  };

  return (
    <Dialog
      open={businessSetUpModalOpen}
      onClose={setBusinessSetUpModalOpen}
      className="relative z-10"
    >
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="w-full relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
              <button
                type="button"
                onClick={() => setBusinessSetUpModalOpen(false)}
                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              >
                <span className="sr-only">Close</span>
                <XMarkIcon aria-hidden="true" className="size-6" />
              </button>
            </div>
            <div>
              <div className="sm:mt-0">
                <DialogTitle
                  as="h3"
                  className="text-center font-semibold text-gray-900"
                >
                  Set up your business
                </DialogTitle>
                <div className="mt-2">
                  <form className="space-y-6">
                    <div>
                      <label
                        htmlFor="businessName"
                        className="block text-sm/6 font-medium text-gray-900"
                      >
                        Business name
                      </label>
                      <div className="mt-2">
                        <input
                          onChange={handleBusinessChange}
                          id="businessName"
                          name="businessName"
                          type="text"
                          required
                          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                        />
                      </div>
                    </div>

                    <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAP_API_KEY} libraries={["places"]}>
                      <PlaceAutocomplete onPlaceSelect={handlePlaceSelect} address=""/>
                      <div className="mt-3 w-full h-[500px] rounded-lg overflow-hidden shadow-lg" style={{marginTop: 10}}>
                        <Map
                          mapId={process.env.REACT_APP_GOOGLE_MAP_ID}
                          defaultCenter={{lat: -37.8136276, lng: 144.9630576}}
                          defaultZoom={13}
                          gestureHandling={'greedy'}
                          onClick={handleMapClick}
                          disableDefaultUI={true}
                        >
                          {selectedLocation && (
                            <AdvancedMarker position={selectedLocation} />
                          )}
                        </Map>
                      </div>
                    </APIProvider>

                    {formError && (
                      <p id="email-error" className="mt-2 text-sm text-red-600">
                        {formError}
                      </p>
                    )}
                  </form>
                </div>
              </div>
            </div>
            <div className="mt-6 sm:flex sm:flex-row-reverse">
              <button
                type="button"
                disabled={loading}
                onClick={handleRegister}
                className={`inline-flex w-full justify-center rounded-md  px-3 py-2 text-sm font-semibold text-white shadow-sm sm:ml-3  sm:w-auto ${loading ? `bg-gray-400 cursor-not-allowed` : `bg-indigo-600 hover:bg-indigo-500`}`}
              >
                {loading ? "Loading..." : "Confirm"}
              </button>
              <button
                type="button"
                onClick={() => setBusinessSetUpModalOpen(false)}
                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
              >
                Cancel
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default BusinessSetUpModal;
